import { LayerList } from "../editor/models/layer.model"

export enum RenderType {
  Free = 'free',
  Premium = 'premium'
}

export interface FirebaseRenderData {
  created: string
  id: string,
  imageSize: number[]
  lastUpdated: string
  renderName: string
  renderType: RenderType
  thumbnailImage: string
  baseDataId: string
  createdTimestamp: number
  editorState?:  {
    layerOrder: string[]
    layers: LayerList
  }
}

export interface FirebaseUsageStats {
  timeStamp: string
  totalActivePlayers: number
  totalFavorites: number
  totalVisits: number
}

export interface GroupFolder {
  id: string
  name: string
  parentFolder: string
}

export interface Comment {
  author: string
  authorId: string
  text: string
  created: string
}

export interface Identifier {
  name: string
  id: string
}

export interface GroupRenderData extends FirebaseRenderData {
  parentFolder: string
  thumbnailExpiration: number
  comments?: Comment[]
  createdBy: Identifier
  updatedBy: Identifier
}
